export enum APIEndpoints {
  // Auth endpoints
  AUTH_LOGIN = "/api/v1/auth/login",
  AUTH_ME = "/api/v1/auth/me",
  AUTH_LOGOUT = "/api/v1/auth/logout",

  // Organization endpoints
  ORGANIZATIONS = "/api/v1/organizations",
  ORGANIZATION_DETAILS = "/api/v1/organizations/:id",

  // Project endpoints
  PROJECTS = "/api/v1/projects",
  PROJECT_DETAILS = "/api/v1/projects/:id",

  // Application endpoints
  APPLICATIONS = "/api/v1/applications",
  APPLICATION_DETAILS = "/api/v1/applications/:id",

  // User endpoints
  USERS = "/api/v1/users",
  USER_DETAILS = "/api/v1/users/:id",
}

export enum HTTPHeaders {
  CONTENT_TYPE = "Content-Type",
  AUTHORIZATION = "Authorization",
  ACCEPT = "Accept",
}

export enum ContentTypes {
  APPLICATION_JSON = "application/json",
  APPLICATION_FORM_URLENCODED = "application/x-www-form-urlencoded",
}
